import React from 'react';
import { NO_MATCH_MESSAGE } from '../../utils/listSearch';

// Detail-pane empty state for when the data exists but search and/or column filters leave nothing
// to show. Offers only the clears that would change something: search, filters, or both.
const NoMatchState = ({ hasSearch, hasFilters, onClearSearch, onClearFilters }) => (
  <>
    <p>{NO_MATCH_MESSAGE}</p>
    <div className="stui-btn-row">
      {hasSearch && <button className="stui-btn stui-btn-secondary" onClick={onClearSearch}>Clear Search</button>}
      {hasFilters && <button className="stui-btn stui-btn-secondary" onClick={onClearFilters}>Clear Filters</button>}
      {hasSearch && hasFilters && (
        <button className="stui-btn stui-btn-primary" onClick={() => { onClearSearch(); onClearFilters(); }}>Clear All</button>
      )}
    </div>
  </>
);

export default NoMatchState;
